var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5228 0 20 4.47715 20 10H18.188C18.188 5.47787 14.5221 1.81196 10 1.81196C5.47787 1.81196 1.81196 5.47795 1.81196 10.0001L0 10C0 4.47715 4.47715 0 10 0Z",
    fill: "#FFBA0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0061 11.0378L11.1574 5.38672H8.82756L8.97885 11.297L11.0061 11.0378Z",
    fill: "#DB990A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72718e-05 9.96661L0 10.0008C0 15.5237 4.47715 20.0008 10 20.0008C15.5228 20.0008 20 15.5237 20 10.0008L19.9999 9.96661H18.188L18.188 10.0008C18.188 14.5229 14.5221 18.1889 10 18.1889C5.47787 18.1889 1.81196 14.5229 1.81196 10.0008L1.81203 9.96661H5.72718e-05Z",
    fill: "#DB990A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99247 14.615C10.7489 14.615 11.3843 14.0706 11.3843 13.4355C11.3843 12.7874 10.7489 12.2431 9.99247 12.2431C9.25118 12.2431 8.61578 12.7874 8.61578 13.4355C8.61578 14.0706 9.25118 14.615 9.99247 14.615Z",
    fill: "#DB990A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.5a0f038bb5a8e879679d553ab731abb4.svg";
export { ForwardRef as ReactComponent };